import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const gButtonGroupCss = ".g__button-group button{font-family:\"Superscripts-Roboto\", \"Roboto\", \"Noto Sans TC\", \"Noto Sans SC\", \"Noto Sans JP\", \"Noto Sans KR\", \"Prompt\", sans-serif}.g__button-group button{font-weight:500}.g__button-group{display:inline-flex;flex-flow:row nowrap;justify-content:space-between;margin-left:0;margin-right:0}.g__button-group button{background-color:#fff;border-radius:0;border:1px solid #000;box-sizing:border-box;color:#000;cursor:pointer;display:inline-block;font-size:1rem;line-height:1.15;margin-left:-1px;overflow:auto;padding:0.875rem 2rem;text-align:center;text-decoration:none;text-transform:uppercase;touch-action:manipulation;transition:background 0.2s, color 0.2s;-webkit-user-select:none;user-select:none;vertical-align:middle}.g__button-group button:first-child{margin-left:0}.g__button-group button:hover{color:#fff;background-color:#000;outline:none}.g__button-group button:focus{outline-offset:-2px}.g__button-group button[aria-pressed=true]{color:#fff;background-color:#000}";
const GButtonGroupStyle0 = gButtonGroupCss;

const GButtonGroup = /*@__PURE__*/ proxyCustomElement(class GButtonGroup extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.label = 'Button Group';
        this.buttons = undefined;
        this.dataTestId = undefined;
    }
    handleClick(event, button) {
        if (button.onClick) {
            button.onClick(event, button);
        }
    }
    handleKeyDown(event, button) {
        if (button.onKeyDown) {
            button.onKeyDown(event, button);
        }
    }
    render() {
        var _a, _b;
        return (h(Host, { key: '00d901ca38e89f7e31014bf03f82aca1ecddbe82', class: "g__button-group", "data-testid": ((_a = this.dataTestId) === null || _a === void 0 ? void 0 : _a.host) || 'g__button-group', role: "group", "aria-label": this.label }, (_b = this.buttons) === null || _b === void 0 ? void 0 : _b.map((button, index) => {
            var _a, _b;
            return (h("button", { type: "button", onClick: (event) => this.handleClick(event, button), onKeyDown: (event) => this.handleKeyDown(event, button), "aria-pressed": button.selected ? 'true' : 'false', "data-testid": (_b = (_a = this.dataTestId) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b[index] }, h("span", { innerHTML: button.content })));
        })));
    }
    static get style() { return GButtonGroupStyle0; }
}, [0, "g-button-group", {
        "label": [1],
        "buttons": [16],
        "dataTestId": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["g-button-group"];
    components.forEach(tagName => { switch (tagName) {
        case "g-button-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, GButtonGroup);
            }
            break;
    } });
}

export { GButtonGroup as G, defineCustomElement as d };

//# sourceMappingURL=g-button-group2.js.map